export enum QuoteFormEventType {
    NoOp = 999999,
    Http404Error = 0,
    IndexLoad = 1,
    IndexPost = 2,
    LeadSubmitBegin = 3,
    LeadSubmitFail = 4,
    LeadSubmitCreated = 5,
    LeadSubmitContinue = 6,
    LeadSubmitContinueFail = 7,
    IncidentsStepLoad = 50,
    VehicleYearStep = 140,
    VehicleMakeStep = 141,
    VehicleModelStep = 142,
    AdditionalVehicleStep = 143,
    CurrentInsuranceStep = 144,
    BeenInsuredStep = 145,
    GenderStep = 146,
    MarriedStep = 147,
    AnyClaimsStep = 148,
    InterestedInFloodInsuranceStep = 149,
    HomeownerStep = 150,
    CreditRatingStep = 151,
    BundleStep = 152,
    BirthYearStep = 153,
    BirthMonthStep = 154,
    BirthDayStep = 155,
    YearBuiltStep = 156,
    PropertyTypeStep = 157,
    ContactInfoFirstStep = 158,
    ContactInfoLastStep = 159,
    BirthYearValidationError = 160,
    YearBuiltValidationError = 161,
    ContactInfoFirstValidationError = 162,
    ContactInfoLastValidationError = 163,
    UserLeftForm = 164,
    CoverageStep = 165,
    PregnancyStep = 166,
    MedicaidLostStep = 167,
    MedicaidEnrollStep = 168,
    ReEngagedLeadSubmitCreated = 179,
    ReEngagedLeadSubmitBegin = 180,
    ReEngagedLeadSummaryPage = 181,
    LicenseStatusStep = 182,
    FilingRequiredStep = 183,
    IsMilitaryStep = 184,
    HouseholdSizeStep = 189,
    HouseholdIncomeStep = 190,
    QualifyingLifeEventStep = 191,
    SelfEmployedStep = 192,
    MajorHealthConditionsStep = 193,
    MajorHealthConditionsSelectStep = 194,
    ConsumerAgeTooYoung = 195,
    OccupancyStep = 196,
    PropertyAddressStep = 197,
    NewlyPurchasedStep = 198,
    CreditHistoryStep = 199,
    CurrentlyInsuredStep = 200,
    InsuranceCarrierStep = 201,
    InsuredSinceStep = 202,
    PolicyExpirationStep = 203,
    AutoAddOnStep = 204,
    AgeStep = 205,
    AdditionalDriverStep = 206,
    AdditionalDriverBirthYearStep = 207,
    AdditionalDriverBirthMonthStep = 208,
    AdditionalDriverBirthDayStep = 209,
    AdditionalDriverNameStep = 210,
    FieldSkippedDataDefaulted = 211,
    FieldSkippedLeadCreationBlocked = 212,
    InterestedInPetInsuranceStep = 213,
}

   